module.exports = __webpack_public_path__ + "static/macbook-5c14ab677e2f69086b46deadd91d3a68.jpg";